<template>
    <b-row class="profile-row">
      <b-col sm="10" offset-sm="1">
        <b-card>
          <b-row>
            <b-col sm="9" v-if=changePassword>
              <b-container class="divider">
              <b-row>
                <b-col class="profile-block">
                  <h2>{{ $t('PROFILE.INFO') }}</h2>
                  <div class="account-info">
                    <b-row>
                      <b-col cols="6">
                        <p class="mb-3"><b>{{ $t('USERS.USERNAME') }}:</b></p>
                      </b-col>
                      <b-col cols="6">
                        <p class="mb-3">{{ user.username }}</p>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="6">
                        <p class="mb-3"><b>{{ $t('USERS.EMAIL') }}:</b></p>
                      </b-col>
                      <b-col cols="6">
                        <p class="mb-3">{{user.email}}</p>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="6">
                        <p class="mb-3"><b>{{ $t('USERS.ROLE') }}:</b></p>
                      </b-col>
                      <b-col cols="6">
                        <p class="mb-3">{{ getRoles | capitalize }}</p>
                      </b-col>
                    </b-row>
                    <!-- <b-row>
                      <b-col cols="6">
                        <p class="mb-3"><b>{{ $t('USERS.TEAM') }}:</b></p>
                      </b-col>
                      <b-col cols="6">
                        <p class="mb-3" >{{ teamName | capitalize }}</p>
                      </b-col>
                    </b-row> -->
                    <b-row>
                      <b-col cols="6">
                        <p class="mb-3"><b>{{ $t('USERS.LAST_LOGIN') }}:</b></p>
                      </b-col>
                      <b-col cols="6">
                        <p class="mb-3">{{ lastLogin }}</p>
                      </b-col>
                    </b-row>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="account-block">
                  <h2>{{ $t('PROFILE.ACCOUNT_INFO') }}</h2>
                  <div class="account-info">
                    <b-row>
                      <b-col cols="6">
                        <p class="mb-3"><b>{{ $t('ACCOUNT.NAME') }}:</b></p>
                      </b-col>
                      <b-col cols="6">
                        <p class="mb-3">{{ getAccountName | capitalize}}</p>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="6">
                        <p><b>{{ $t('PROFILE.MEMBERS') }}</b></p>
                      </b-col>
                      <b-col cols="6">
                        <p>{{members}}</p>
                      </b-col>
                    </b-row>
                  </div>
                </b-col>
              </b-row>
              </b-container>           
            </b-col>
            <b-col sm="9" v-if=!changePassword>
              <b-container class="divider">
                <b-row>
                  <b-col class="profile-block">
                    <h2 class="text-center">{{ $t('AUTH.PWD_CHANGE') }}</h2>  
                    <p>{{ $t('AUTH.PWD_CURRENT') }}</p>                
                  <b-input-group class="mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text"><i class="icon-lock"></i></span>
                    </div>
                    <input type="password" 
                          class="form-control" 
                          :class="{'is-invalid': $v.user.password.$error, 'is-valid': !$v.user.password.$invalid}"
                          :placeholder="$t('AUTH.PWD_CURRENT')"
                          v-model="user.password"
                          @blur="$v.user.password.$touch()">
                      <b-form-invalid-feedback v-if="!$v.user.password.required">{{ $t('USERS.REQ_PASS') }}</b-form-invalid-feedback>
                      <b-form-invalid-feedback v-if="!$v.user.password.minLen">{{ $t('USERS.REQ_PASS_MIN_LENGHT') }}</b-form-invalid-feedback>
                  </b-input-group> 
                  <p>{{ $t('AUTH.NEW_PASSWORD')}}</p>             
                  <b-input-group class="mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text"><i class="icon-lock"></i></span>
                    </div>
                    <input type="password" 
                          class="form-control" 
                          :class="{'is-invalid': $v.user.password_new.$error, 'is-valid': !$v.user.password_new.$invalid}"
                          :placeholder="$t('AUTH.NEW_PASSWORD')"
                          v-model="user.password_new"
                          @blur="$v.user.password_new.$touch()">
                      <b-form-invalid-feedback v-if="!$v.user.password_new.required">{{ $t('USERS.REQ_PASS') }}</b-form-invalid-feedback>
                      <b-form-invalid-feedback v-if="!$v.user.password_new.minLen">{{ $t('USERS.REQ_PASS_MIN_LENGHT') }}</b-form-invalid-feedback>
                  </b-input-group>
                  <p> {{ $t('AUTH.CONFIRM_PASSWORD')}} </p>
                  <b-input-group class="mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text"><i class="icon-lock"></i></span>
                    </div>
                    <input type="password" 
                         class="form-control" 
                         :class="{'is-invalid': $v.user.password_confirm.$error, 'is-valid': !$v.user.password_confirm.$invalid}"
                         :placeholder="$t('AUTH.CONFIRM_PASSWORD')"
                         v-model="user.password_confirm"
                         @blur="$v.user.password_confirm.$touch()">
                    <b-form-invalid-feedback v-if="!$v.user.password_confirm.SameAs">{{ $t('USERS.REQ_NO_MATCH') }}</b-form-invalid-feedback>
                  </b-input-group>    
                </b-col>
              </b-row>
              </b-container>
              <b-container>
                <b-row>
                  <b-col class="text-center">
                    <b-btn class="save-btn" variant="light" @click="resetUpdatePassword">{{$t('COMMON.CANCEL')}}</b-btn>
                  </b-col>
                  <b-col>
                   <b-btn class="save-btn"  @click="updatePassword" :disabled="$v.$invalid">{{ $t('COMMON.SAVE') }}</b-btn>
                  </b-col>
                </b-row>
              </b-container>
            </b-col>
            <b-col sm="3">
              <div class="pfp-container">
                <v-gravatar :email="user.email" class="pfp" :alt="user.email"/>
                <p>{{ currentUserEmail.split('@')[0] | capitalize}}</p>
              </div>
              <br />
              <b-button-group class="d-flex justify-content-center">
              <!-- <b-btn v-if=changePassword @click="changePassword = !changePassword">{{ $t('AUTH.PWD_CHANGE') }}</b-btn> -->
              </b-button-group>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import svg from '../../_svg.js'
import { minLength, sameAs, required } from 'vuelidate/lib/validators'

export default {
  data () {
    return {
      user: {
        role: '',
        username: '',
        email: '',
        password: '',
        password_new: '',
        password_confirm: ''
      },
      changePassword: true,
      teamName: '',
      lastLogin: '',
      selected: '',
      accountName: '',
      members: '',
      svg: svg,
      showPassword: false
    }
  },
  validations: {
    user: {
      password: {
        required,
        minLen: minLength(8)
      },
      password_new: {
        required,
        minLen: minLength(8)
      },
      password_confirm: {
        required,
        sameAs: sameAs(vm => { return vm.password_new })
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      Vue.axios.get('/users/' + vm.currentUserId, { headers: { Authorization: `Bearer ${vm.idToken}` } })
        .then(res => {
          let user = res.data.user
          vm.user.username = user.username
          vm.user.email = user.email
          vm.user.role = vm.userRole
          vm.accountName = user.account_name
          vm.members = user.account_members
          vm.teamName = user.team_id ? user.teams.filter(team => team.id === user.team_id)[0].name : 'N/A'
          vm.lastLogin = user.last_login_at
          next()
        })
        .catch(error => {
          if (error.status === 401) {
            Vue.toasted.show(vm.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else {
            Vue.toasted.show(vm.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
            next(false)
          }
        })
    })
  },
  methods: {
    resetUpdatePassword () {
      this.user.password = ''
      this.user.password_new = ''
      this.user.password_confirm = ''
      this.changePassword = !this.changePassword
    },
    updatePassword () {
      let data = new window.FormData()
      data.append('username', this.user.username)
      data.append('current_password', this.user.password)
      data.append('password', this.user.password_new)
      data.append('password_confirmation', this.user.password_confirm)
      Vue.axios.patch('/users/' + this.currentUserId, data, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          if (res.data.error) {
            Vue.toasted.show(res.data.error, { icon: 'chain-broken', type: 'error' })
          } else if (res.data.status === 101) {
            Vue.toasted.show(this.$t('PROFILE.WRONG_PASSWORD'), { icon: 'chain-broken', type: 'error' })
          } else {
            Vue.toasted.show(this.$t('PROFILE.UPDATE_SUCCESS'))
            this.changePassword = !this.changePassword
          }
        })
        .catch(error => {
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else {
            Vue.toasted.show(this.$t('COMMON.MSG_RETRY'), { icon: 'chain-broken', type: 'error' })
          }
        })
    }
  },
  computed: {
    ...mapGetters(['idToken', 'currentUserId', 'userRole', 'currentUserEmail']),
    getPasswordIcon () {
      let passwordIcon
      if (this.showPassword) {
        passwordIcon = svg.eyeSlash
      } else {
        passwordIcon = svg.eye
      }
      return passwordIcon
    },
    getRoles () {
      if (this.user.role === 'super admin') {
        return this.$t('PROFILE.ROLES.SUPERADMIN')
      } else if (this.user.role === 'admin') {
        return this.$t('PROFILE.ROLES.ADMIN')
      } else {
        return this.user.role
      }
    },
    getAccountName () {
      if (this.accountName === 'default') {
        return this.$t('PROFILE.ACCNAME.DEFAULT')
      } else {
        return this.accountName
      }
    }
  }
}
</script>


<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/profile/index.vue